import { observer } from 'mobx-react-lite'
import { TbMapPin, TbMapPinOff } from 'react-icons/tb'

import { RelatedRecords } from '../../Components/RelatedRecords/RelatedRecords'
import { ResourceViewFields } from '../../Components/ResourceViewFields/ResourceViewFields'
import { useRelatedRecords } from '../../Hooks/useRelatedRecords'
import { ListRegionResource } from '../../Resources/ListRegionResource'

/**
 * Картка кластера (перегляд): поля довідника і під ними секція «Регіони» — плитки
 * регіонів цього кластера; клік відкриває картку регіону.
 */
export const ClusterViewTemplate = observer(({ crudContext, formContext }: any) => {
    const regions = useRelatedRecords('/services/lists/regions', 'cluster', formContext?.values?.code)

    return (
        <>
            <ResourceViewFields crudContext={crudContext} formContext={formContext} />
            <RelatedRecords
                title="Регіони"
                state={regions}
                resource={ListRegionResource}
                icon={TbMapPin}
                inactiveIcon={TbMapPinOff}
                emptyText="У кластері ще немає регіонів"
            />
        </>
    )
})
